import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/payment-plans/payment-methods/:paymentMethodId']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];
type Output = ThisApi['response'];

const updatePaymentMethodForPerson = async ({ paymentMethodId, currentPaymentMethodId }: Input): Promise<Output> => {
  const response = await noodleApiClient.put(`/payment-plans/payment-methods/${paymentMethodId}`, {
    currentPaymentMethodId,
  });
  return response.data;
};

export default updatePaymentMethodForPerson;
